module.exports = __webpack_public_path__ + "img/tempImage.99b6ca52.png";